

 <div class="page-breadcrumb">
        <div class="row">
            <div class="col-7 align-self-center">
                <div class="d-flex align-items-center">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a routerLink="/mainview/dashboard" class="link">Dashboard</a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Approval primary User</li>
                        </ol>
                    </nav>
                </div>
                <h4 class="page-title">Approval primary User</h4>
            </div>
          
        </div>
    </div>

<div class="container-fluid" style="margin-top: 20px">
        <div class="card">
            <!-- Tabs -->
            <ul class="nav nav-tabs" id="pills-tab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="pills-timeline-tab" data-toggle="pill" href="#current-month" role="tab" aria-controls="pills-timeline"
                        aria-selected="true">Requests For Approval</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#last-month" role="tab" aria-controls="pills-profile"
                        aria-selected="false">Requests History</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="pills-setting-tab" data-toggle="pill" href="#previous-month" role="tab" aria-controls="pills-setting"
                        aria-selected="false">Edit Permission List</a>
                </li>
            </ul>
            <!-- Tabs -->
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="current-month" role="tabpanel" aria-labelledby="pills-timeline-tab">
                    <div class="container-fluid">
                        <!-- ============================================================== -->
                        <!-- Start Page Content -->
                        <!-- ============================================================== -->
                        <div class="row">
                            <!-- Column -->
                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-body">
                                        <form action="#">
                                            <div>
                                                <h5>Primary User 1</h5>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="control-label">User Id</label>
                                                            <input type="text" id="userId" class="form-control" placeholder=" User Id">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="control-label">User Name</label>
                                                            <input type="text" id="userName" class="form-control" placeholder=" User Name">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="control-label"> Email ID</label>
                                                            <input type="text" id="emailId" class="form-control" placeholder=" Email Id">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="control-label">Mobile Number</label>
                                                            <input type="tel" id="mobile" class="form-control" placeholder="Mobile Number">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="control-label">Date and Time</label>
                                                            <input type="text" id="date and time" class="form-control" placeholder=" Date and Time">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <br>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="customRadioInline1" name="customRadioInline1" (change)="approval()" class="custom-control-input">
                                                                <label class="custom-control-label" for="customRadioInline1">Approve</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="customRadioInline2" name="customRadioInline1" (change)="reject()" class="custom-control-input">
                                                                <label class="custom-control-label" for="customRadioInline2">Reject</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" *ngIf="show">
                                                    <div class="col-md-3">
                                                        <label>Current Inventory</label>
    
                                                    </div>
                                                    <div class="col-md-3">
    
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="currentInventoryYes" name="currentInventory" class="custom-control-input">
                                                                <label class="custom-control-label" for="currentInventoryYes">Yes</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="currentInventoryNo" name="currentInventory" class="custom-control-input">
                                                                <label class="custom-control-label" for="currentInventoryNo">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                                <div class="row" *ngIf="show">
                                                    <div class="col-md-3">
                                                        <label>Shopping Cart</label>
    
                                                    </div>
                                                    <div class="col-md-3">
    
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="ShoppingCartYes" name="ShoppingCart" class="custom-control-input">
                                                                <label class="custom-control-label" for="ShoppingCartYes">Yes</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="ShoppingCartNo" name="ShoppingCart" class="custom-control-input">
                                                                <label class="custom-control-label" for="ShoppingCartNo">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                                <div class="row" *ngIf="show">
                                                    <div class="col-md-3">
                                                        <label>Open Orders</label>
    
                                                    </div>
                                                    <div class="col-md-3">
    
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="OpenOrdersYes" name="OpenOrders" class="custom-control-input">
                                                                <label class="custom-control-label" for="OpenOrdersYes">Yes</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="OpenOrdersNo" name="OpenOrders" class="custom-control-input">
                                                                <label class="custom-control-label" for="OpenOrdersNo">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                                <div class="row" *ngIf="show">
                                                    <div class="col-md-3">
                                                        <label>Order History</label>
    
                                                    </div>
                                                    <div class="col-md-3">
    
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="OrderHistoryYes" name="OrderHistory" class="custom-control-input">
                                                                <label class="custom-control-label" for="OrderHistoryYes">Yes</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="OrderHistoryNo" name="OrderHistory" class="custom-control-input">
                                                                <label class="custom-control-label" for="OrderHistoryNo">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                                <div class="row" *ngIf="show">
                                                    <div class="col-md-3">
                                                        <label>Vendor Masters</label>
    
                                                    </div>
                                                    <div class="col-md-3">
    
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="VendorMastersYes" name="VendorMasters" class="custom-control-input">
                                                                <label class="custom-control-label" for="VendorMastersYes">Yes</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="VendorMastersNo" name="VendorMasters" class="custom-control-input">
                                                                <label class="custom-control-label" for="VendorMastersNo">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                                <div class="form-actions m-t-40">
                                                    <button type="submit" class="btn btn-info"> Submit</button>
                                                </div>
                                            </div>
                                            <br>&nbsp;&nbsp;
    
                                        </form>
                                        <br>
                                        <form action="#">
                                            <div>
                                                <h5>Primary User 2</h5>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="control-label">User Id</label>
                                                            <input type="text" id="userId" class="form-control" placeholder=" User Id">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="control-label">User Name</label>
                                                            <input type="text" id="userName" class="form-control" placeholder=" User Name">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="control-label"> Email ID</label>
                                                            <input type="text" id="emailId" class="form-control" placeholder=" Email Id">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="control-label">Mobile Number</label>
                                                            <input type="tel" id="mobile" class="form-control" placeholder="Mobile Number">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="control-label">Date and Time</label>
                                                            <input type="text" id="date and time" class="form-control" placeholder=" Date and Time">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <br>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="customRadioInline1" name="customRadioInline1" (change)="approval()" class="custom-control-input">
                                                                <label class="custom-control-label" for="customRadioInline1">Approve</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="customRadioInline2" name="customRadioInline1" (change)="reject()" class="custom-control-input">
                                                                <label class="custom-control-label" for="customRadioInline2">Reject</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" *ngIf="show">
                                                    <div class="col-md-3">
                                                        <label>Current Inventory</label>
    
                                                    </div>
                                                    <div class="col-md-3">
    
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="currentInventoryYes" name="currentInventory" class="custom-control-input">
                                                                <label class="custom-control-label" for="currentInventoryYes">Yes</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="currentInventoryNo" name="currentInventory" class="custom-control-input">
                                                                <label class="custom-control-label" for="currentInventoryNo">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                                <div class="row" *ngIf="show">
                                                    <div class="col-md-3">
                                                        <label>Shopping Cart</label>
    
                                                    </div>
                                                    <div class="col-md-3">
    
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="ShoppingCartYes" name="ShoppingCart" class="custom-control-input">
                                                                <label class="custom-control-label" for="ShoppingCartYes">Yes</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="ShoppingCartNo" name="ShoppingCart" class="custom-control-input">
                                                                <label class="custom-control-label" for="ShoppingCartNo">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                                <div class="row" *ngIf="show">
                                                    <div class="col-md-3">
                                                        <label>Open Orders</label>
    
                                                    </div>
                                                    <div class="col-md-3">
    
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="OpenOrdersYes" name="OpenOrders" class="custom-control-input">
                                                                <label class="custom-control-label" for="OpenOrdersYes">Yes</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="OpenOrdersNo" name="OpenOrders" class="custom-control-input">
                                                                <label class="custom-control-label" for="OpenOrdersNo">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                                <div class="row" *ngIf="show">
                                                    <div class="col-md-3">
                                                        <label>Order History</label>
    
                                                    </div>
                                                    <div class="col-md-3">
    
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="OrderHistoryYes" name="OrderHistory" class="custom-control-input">
                                                                <label class="custom-control-label" for="OrderHistoryYes">Yes</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="OrderHistoryNo" name="OrderHistory" class="custom-control-input">
                                                                <label class="custom-control-label" for="OrderHistoryNo">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                                <div class="row" *ngIf="show">
                                                    <div class="col-md-3">
                                                        <label>Vendor Masters</label>
    
                                                    </div>
                                                    <div class="col-md-3">
    
                                                        <div class="form-group">
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="VendorMastersYes" name="VendorMasters" class="custom-control-input">
                                                                <label class="custom-control-label" for="VendorMastersYes">Yes</label>
                                                            </div>
                                                            <div class="custom-control custom-radio custom-control-inline">
                                                                <input type="radio" id="VendorMastersNo" name="VendorMasters" class="custom-control-input">
                                                                <label class="custom-control-label" for="VendorMastersNo">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                                <div class="form-actions m-t-40">
                                                    <button type="submit" class="btn btn-info"> Submit</button>
                                                </div>
                                            </div>
                                            <br>&nbsp;&nbsp;
    
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <!-- Column -->
                        </div>
                        <!-- ============================================================== -->
                        <!-- End PAge Content -->
    
                        <!-- ============================================================== -->
                    </div>
                </div>
                <div class="tab-pane fade" id="last-month" role="tabpanel" aria-labelledby="pills-profile-tab">
    
                    <div class="container-fluid">
                        <!-- ============================================================== -->
                        <!-- Start Page Content -->
                        <!-- ============================================================== -->
    
                        <div _ngcontent-ust-c20="" class="card">
                            <div _ngcontent-ust-c20="" class="card-body">
                                <div _ngcontent-ust-c20="" class="table-responsive">
                                    <div _ngcontent-ust-c20="" id="zero_config_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                                        <div _ngcontent-ust-c20="" class="row">
                                            <div _ngcontent-ust-c20="" class="col-sm-12 col-md-6">
                                                <div _ngcontent-ust-c20="" id="zero_config_length" class="dataTables_length">
                                                    <label _ngcontent-ust-c20="">Show
                                                        <select _ngcontent-ust-c20="" name="zero_config_length" aria-controls="zero_config" class="form-control form-control-sm">
                                                            <option _ngcontent-ust-c20="" value="10">10</option>
                                                            <option _ngcontent-ust-c20="" value="25">25</option>
                                                            <option _ngcontent-ust-c20="" value="50">50</option>
                                                            <option _ngcontent-ust-c20="" value="100">100</option>
                                                        </select> entries</label>
                                                </div>
                                            </div>
                                            <div _ngcontent-ust-c20="" class="col-sm-12 col-md-6">
                                                <div _ngcontent-ust-c20="" id="zero_config_filter" class="dataTables_filter">
                                                    <label _ngcontent-ust-c20="">Search:
                                                        <input _ngcontent-ust-c20="" type="search" placeholder="" aria-controls="zero_config" class="form-control form-control-sm">
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div _ngcontent-ust-c20="" class="row">
                                            <div _ngcontent-ust-c20="" class="col-sm-12">
                                                <table _ngcontent-ust-c20="" id="zero_config" role="grid" aria-describedby="zero_config_info" class="table product-overview v-middle dataTable no-footer">
                                                    <thead style="background-color:   #b13a9dbe;color:white;font-size: 19px">
                                                        <tr>
                                                            <th>User Name</th>
                                                            <th>User Id</th>
                                                            <th>Email Id</th>
                                                            <th>Mobile Number</th>
                                                            <th>Date and Time</th>
                                                            <th>Approve/Reject</th>
                                                            <th>Commets </th>
    
    
    
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>1</td>
                                                            <td>Foo</td>
                                                            <td>Bar</td>
                                                            <td>Foo</td>
                                                            <td>Bar</td>
                                                            <td>Foo</td>
                                                            <td>Bar</td>
    
    
                                                        </tr>
                                                        <tr>
                                                            <td>2</td>
                                                            <td>Someone</td>
                                                            <td>Youknow</td>
                                                            <td>Someone</td>
                                                            <td>Youknow</td>
                                                            <td>Foo</td>
                                                            <td>Bar</td>
    
    
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-5">
                                                <div id="zero_config_info" role="status" aria-live="polite" class="dataTables_info">Showing 1 to 8 of 8 entries</div>
                                            </div>
                                            <div class="col-sm-12 col-md-7">
                                                <div id="zero_config_paginate" class="dataTables_paginate paging_simple_numbers">
                                                    <ul class="pagination">
                                                        <li id="zero_config_previous" class="paginate_button page-item previous disabled">
                                                            <a href="#" aria-controls="zero_config" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                                        </li>
                                                        <li class="paginate_button page-item active">
                                                            <a href="#" aria-controls="zero_config" data-dt-idx="1" tabindex="0" class="page-link">1</a>
                                                        </li>
                                                        <li id="zero_config_next" class="paginate_button page-item next disabled">
                                                            <a href="#" aria-controls="zero_config" data-dt-idx="2" tabindex="0" class="page-link">Next</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- ============================================================== -->
                        <!-- End PAge Content -->
                        <!-- ============================================================== -->
                        <!-- ============================================================== -->
                        <!-- Right sidebar -->
                        <!-- ============================================================== -->
                        <!-- .right-sidebar -->
                        <!-- ============================================================== -->
                        <!-- End Right sidebar -->
                        <!-- ============================================================== -->
                    </div>
                </div>
                <div class="tab-pane fade" id="previous-month" role="tabpanel" aria-labelledby="pills-setting-tab">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Category</label>
                                    <select class="form-control" data-placeholder="Choose a Category" tabindex="1">
                                        <option value="Category 1">Category 1</option>
                                        <option value="Category 2">Category 2</option>
                                        <option value="Category 3">Category 5</option>
                                        <option value="Category 4">Category 4</option>
                                    </select>
                                </div>
                            </div>
                        </div>
    
    
                        <div class="row">
                            <div class="col-md-3">
                                <label>Current Inventory</label>
    
                            </div>
                            <div class="col-md-3">
    
                                <div class="form-group">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="currentInventoryYes" name="currentInventory" class="custom-control-input">
                                        <label class="custom-control-label" for="currentInventoryYes">Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="currentInventoryNo" name="currentInventory" class="custom-control-input">
                                        <label class="custom-control-label" for="currentInventoryNo">No</label>
                                    </div>
                                </div>
                            </div>
    
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label>Shopping Cart</label>
    
                            </div>
                            <div class="col-md-3">
    
                                <div class="form-group">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="ShoppingCartYes" name="ShoppingCart" class="custom-control-input">
                                        <label class="custom-control-label" for="ShoppingCartYes">Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="ShoppingCartNo" name="ShoppingCart" class="custom-control-input">
                                        <label class="custom-control-label" for="ShoppingCartNo">No</label>
                                    </div>
                                </div>
                            </div>
    
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label>Open Orders</label>
    
                            </div>
                            <div class="col-md-3">
    
                                <div class="form-group">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="OpenOrdersYes" name="OpenOrders" class="custom-control-input">
                                        <label class="custom-control-label" for="OpenOrdersYes">Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="OpenOrdersNo" name="OpenOrders" class="custom-control-input">
                                        <label class="custom-control-label" for="OpenOrdersNo">No</label>
                                    </div>
                                </div>
                            </div>
    
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label>Order History</label>
    
                            </div>
                            <div class="col-md-3">
    
                                <div class="form-group">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="OrderHistoryYes" name="OrderHistory" class="custom-control-input">
                                        <label class="custom-control-label" for="OrderHistoryYes">Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="OrderHistoryNo" name="OrderHistory" class="custom-control-input">
                                        <label class="custom-control-label" for="OrderHistoryNo">No</label>
                                    </div>
                                </div>
                            </div>
    
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label>Vendor Masters</label>
    
                            </div>
                            <div class="col-md-3">
    
                                <div class="form-group">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="VendorMastersYes" name="VendorMasters" class="custom-control-input">
                                        <label class="custom-control-label" for="VendorMastersYes">Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" id="VendorMastersNo" name="VendorMasters" class="custom-control-input">
                                        <label class="custom-control-label" for="VendorMastersNo">No</label>
                                    </div>
                                </div>
                            </div>
    
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>